import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  getPanelErrorProps,
  TextTitle,
  ValidatedPanel,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { andComp, propertyIs, entityIs } from '@bingads-webui-campaign-react/form-error';

import { ValidatedBusinessNameWithRecommendation } from './business-name-with-recommendation';
import BusinessNameImg from '../media/business-name.svg';

const getBusinessNameProp = (entity) => {
  const businessNameProp = andComp(entityIs(entity), propertyIs('BusinessName'));
  return businessNameProp;
};

export const ValidatedBusinessNameWithRecommendationSection = React.memo((props) => {
  const {
    businessName, expand, entity, ...rest
  } = props;
  const i18n = useContext(I18nContext);
  const nativeAdBusinessNameProp = useMemo(() => getBusinessNameProp(entity), [entity]);

  return (
    <ValidatedPanel
      key="business-name"
      title={<TextTitle
        titleKey={_TL_('Business name')}
        topicKey="pop_BA_CampaignCreate_AudAds_BusinessName"
        icon={BusinessNameImg}
        iconAltText={i18n.getString(_TL_('"Business name" panel\'s image'))}
        details={businessName}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'business-name',
      }}
      {...rest}
    >
      <ValidatedBusinessNameWithRecommendation
        id="input-business-name"
        i18n={i18n}
        validationProps={{
          data: { BusinessName: businessName },
          initialValue: { BusinessName: businessName },
        }}
        formErrorProps={{ filter: nativeAdBusinessNameProp }}
      />
    </ValidatedPanel>
  );
});

ValidatedBusinessNameWithRecommendationSection.propTypes = {
  businessName: PropTypes.string.isRequired,
  entity: PropTypes.string.isRequired,
  expand: PropTypes.func.isRequired,
};
